let activeFormId = null;

export function initPeriodiekTerugbetalenPage() {
    const container = document.querySelector("[data-show-add-blocked]");
    const cesKey = container?.dataset.periodicCesKey;

    if (container?.dataset.showAddBlocked === "true") {
        window.dialog.open({ elemId: 'addBlockedDialog' });
    }

    if (container?.dataset.showEndBlocked === "true") {
        window.dialog.open({ elemId: 'endBlockedDialog' });
    }

    window.customerEffortScore.trigger(cesKey);    

    document.querySelectorAll('.js-beeindigen').forEach(btn => {
        btn.addEventListener('click', () => beeindigen(btn.dataset.formId));
    });

    document.addEventListener('click', (e) => {
        if (e.target.closest('#pea-confirm-btn')) {
            endPea();
        }
        if (e.target.closest('.js-dialog-close')) {
            window.dialog.close();
        }
    });
}

function beeindigen(formId) {
    activeFormId = formId;
    window.dialog.open({ elemId: 'confirmDialog' });
}

function endPea() {
    if (activeFormId) {
        window.dialog.close();
        document.getElementById(activeFormId)?.submit();
    }
}
